// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as GraphqlTag from "graphql-tag";
import * as SpaceX$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/SpaceX.res.mjs";
import * as QueryHook2$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/QueryHook2.res.mjs";
import * as HasuraTypes$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/HasuraTypes.res.mjs";
import * as UserContext$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/UserContext.res.mjs";
import * as ProfileTypes$LiteracyplanetClientSxEntry from "./ProfileTypes.res.mjs";
import * as AvatarFragments$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/AvatarFragments.res.mjs";
import * as BadgeTypes$LiteracyplanetSharedClientProfile from "@literacyplanet/shared-client-profile/src/BadgeTypes.res.mjs";
import * as StoryverseNavigationQuery$LiteracyplanetClientSxEntry from "../StoryverseNavigationQuery.res.mjs";

var Raw = {};

var query = GraphqlTag.gql([
      "query profileQuery($nextUuid: ID!, $userId: String!, $userUuid: uuid!, $myUserId: String!, $myUserIdUuid: uuid!)  {\npublicStudentProfile(nextUuid: $nextUuid)  {\n__typename  \nnextUuid  \nshortName  \ngems  \ncountry  {\n__typename  \ntwoLetterCode  \n}\n\n}\n\ngetPlayerAvatar(userId: $userId)  {\n...PlayerEquippedFragment   \n}\n\ntrophies(where: {userId: {_eq: $userUuid}})  {\n__typename  \nsource  \nbronze  \nsilver  \ngold  \n}\n\nstoryverse_user_points_view(where: {userId: {_eq: $userUuid}})  {\n...StoryverseUserPointsFragment   \n}\n\nbadges: student_badge_collection(args: {p_user_uuid: $userUuid})  {\n__typename  \nbadgeName  \ntitleColour  \ndescription  \ntexture  \ncollected  \ndata  \n}\n\ncurrentStudent(userId: $myUserId)  {\n__typename  \ngems  \n}\n\nhighFives: high_fives_by_pk(userId: $myUserIdUuid)  {\n__typename  \nreceived  \ngiven  \n}\n\nthumbsUp: thumbs_up_by_pk(userId: $myUserIdUuid)  {\n__typename  \nreceived  \ngiven  \n}\n\n}\n",
      "",
      ""
    ], AvatarFragments$LiteracyplanetClientFlags.PlayerEquippedFragment.query, StoryverseNavigationQuery$LiteracyplanetClientSxEntry.StoryverseUserPointsFragment.query);

function parse(value) {
  var value$1 = value.publicStudentProfile;
  var value$2 = value$1.shortName;
  var value$3 = value$1.country;
  var value$4 = value.getPlayerAvatar;
  var value$5 = value.trophies;
  var value$6 = value.storyverse_user_points_view;
  var value$7 = value.badges;
  var value$8 = value.currentStudent;
  var value$9 = value.highFives;
  var value$10 = value.thumbsUp;
  return {
          publicStudentProfile: {
            __typename: value$1.__typename,
            nextUuid: value$1.nextUuid,
            shortName: !(value$2 == null) ? value$2 : undefined,
            gems: value$1.gems,
            country: !(value$3 == null) ? ({
                  __typename: value$3.__typename,
                  twoLetterCode: value$3.twoLetterCode
                }) : undefined
          },
          getPlayerAvatar: !(value$4 == null) ? AvatarFragments$LiteracyplanetClientFlags.PlayerEquippedFragment.verifyArgsAndParse("PlayerEquippedFragment", value$4) : undefined,
          trophies: value$5.map(function (value) {
                return {
                        __typename: value.__typename,
                        source: value.source,
                        bronze: value.bronze,
                        silver: value.silver,
                        gold: value.gold
                      };
              }),
          storyverse_user_points_view: value$6.map(function (value) {
                return StoryverseNavigationQuery$LiteracyplanetClientSxEntry.StoryverseUserPointsFragment.verifyArgsAndParse("StoryverseUserPointsFragment", value);
              }),
          badges: value$7.map(function (value) {
                return {
                        __typename: value.__typename,
                        badgeName: value.badgeName,
                        titleColour: value.titleColour,
                        description: value.description,
                        texture: value.texture,
                        collected: value.collected,
                        data: value.data
                      };
              }),
          currentStudent: !(value$8 == null) ? ({
                __typename: value$8.__typename,
                gems: value$8.gems
              }) : undefined,
          highFives: !(value$9 == null) ? ({
                __typename: value$9.__typename,
                received: value$9.received,
                given: value$9.given
              }) : undefined,
          thumbsUp: !(value$10 == null) ? ({
                __typename: value$10.__typename,
                received: value$10.received,
                given: value$10.given
              }) : undefined
        };
}

function serialize(value) {
  var value$1 = value.thumbsUp;
  var thumbsUp;
  if (value$1 !== undefined) {
    var value$2 = value$1.given;
    var value$3 = value$1.received;
    var value$4 = value$1.__typename;
    thumbsUp = {
      __typename: value$4,
      received: value$3,
      given: value$2
    };
  } else {
    thumbsUp = null;
  }
  var value$5 = value.highFives;
  var highFives;
  if (value$5 !== undefined) {
    var value$6 = value$5.given;
    var value$7 = value$5.received;
    var value$8 = value$5.__typename;
    highFives = {
      __typename: value$8,
      received: value$7,
      given: value$6
    };
  } else {
    highFives = null;
  }
  var value$9 = value.currentStudent;
  var currentStudent;
  if (value$9 !== undefined) {
    var value$10 = value$9.gems;
    var value$11 = value$9.__typename;
    currentStudent = {
      __typename: value$11,
      gems: value$10
    };
  } else {
    currentStudent = null;
  }
  var value$12 = value.badges;
  var badges = value$12.map(function (value) {
        var value$1 = value.data;
        var value$2 = value.collected;
        var value$3 = value.texture;
        var value$4 = value.description;
        var value$5 = value.titleColour;
        var value$6 = value.badgeName;
        var value$7 = value.__typename;
        return {
                __typename: value$7,
                badgeName: value$6,
                titleColour: value$5,
                description: value$4,
                texture: value$3,
                collected: value$2,
                data: value$1
              };
      });
  var value$13 = value.storyverse_user_points_view;
  var storyverse_user_points_view = value$13.map(function (value) {
        return StoryverseNavigationQuery$LiteracyplanetClientSxEntry.StoryverseUserPointsFragment.serialize(value);
      });
  var value$14 = value.trophies;
  var trophies = value$14.map(function (value) {
        var value$1 = value.gold;
        var value$2 = value.silver;
        var value$3 = value.bronze;
        var value$4 = value.source;
        var value$5 = value.__typename;
        return {
                __typename: value$5,
                source: value$4,
                bronze: value$3,
                silver: value$2,
                gold: value$1
              };
      });
  var value$15 = value.getPlayerAvatar;
  var getPlayerAvatar = value$15 !== undefined ? AvatarFragments$LiteracyplanetClientFlags.PlayerEquippedFragment.serialize(value$15) : null;
  var value$16 = value.publicStudentProfile;
  var value$17 = value$16.country;
  var country;
  if (value$17 !== undefined) {
    var value$18 = value$17.twoLetterCode;
    var value$19 = value$17.__typename;
    country = {
      __typename: value$19,
      twoLetterCode: value$18
    };
  } else {
    country = null;
  }
  var value$20 = value$16.gems;
  var value$21 = value$16.shortName;
  var shortName = value$21 !== undefined ? value$21 : null;
  var value$22 = value$16.nextUuid;
  var value$23 = value$16.__typename;
  var publicStudentProfile = {
    __typename: value$23,
    nextUuid: value$22,
    shortName: shortName,
    gems: value$20,
    country: country
  };
  return {
          publicStudentProfile: publicStudentProfile,
          getPlayerAvatar: getPlayerAvatar,
          trophies: trophies,
          storyverse_user_points_view: storyverse_user_points_view,
          badges: badges,
          currentStudent: currentStudent,
          highFives: highFives,
          thumbsUp: thumbsUp
        };
}

function serializeVariables(inp) {
  return {
          nextUuid: inp.nextUuid,
          userId: inp.userId,
          userUuid: inp.userUuid,
          myUserId: inp.myUserId,
          myUserIdUuid: inp.myUserIdUuid
        };
}

function makeVariables(nextUuid, userId, userUuid, myUserId, myUserIdUuid, param) {
  return {
          nextUuid: nextUuid,
          userId: userId,
          userUuid: userUuid,
          myUserId: myUserId,
          myUserIdUuid: myUserIdUuid
        };
}

var GetProfile_inner = {
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  makeVariables: makeVariables
};

var include = SpaceX$LiteracyplanetClientFlags.Query.Extend({
      query: query,
      Raw: Raw,
      parse: parse,
      serialize: serialize,
      serializeVariables: serializeVariables
    });

var use = include.use;

var useFetch = include.useFetch;

var GetProfile = {
  GetProfile_inner: GetProfile_inner,
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  makeVariables: makeVariables,
  use: use,
  useFetch: useFetch
};

function makeBadges(res) {
  return Belt_Array.map(res.badges, (function (b) {
                return {
                        title: b.badgeName,
                        titleColour: b.titleColour,
                        description: b.description,
                        texture: b.texture,
                        unlocked: b.collected,
                        rule: BadgeTypes$LiteracyplanetSharedClientProfile.parseJsonData(b.data)
                      };
              }));
}

function makeTrophies(res) {
  return ProfileTypes$LiteracyplanetClientSxEntry.makeTrophyState(Belt_Array.map(res.trophies, (function (t) {
                    return {
                            source: t.source,
                            bronze: t.bronze,
                            silver: t.silver,
                            gold: t.gold
                          };
                  })));
}

function makeMyGems(res) {
  return Belt_Option.mapWithDefault(res.currentStudent, 0, (function (param) {
                return param.gems;
              }));
}

function defaultSocial(social) {
  return Belt_Option.mapWithDefault(social, {
              given: 0,
              received: 0
            }, (function (param) {
                return {
                        given: param.given,
                        received: param.received
                      };
              }));
}

function handleResponse(res) {
  return {
          user: {
            userId: res.publicStudentProfile.nextUuid,
            shortName: Belt_Option.getWithDefault(res.publicStudentProfile.shortName, ""),
            gems: res.publicStudentProfile.gems,
            country: Belt_Option.mapWithDefault(res.publicStudentProfile.country, "", (function (c) {
                    return c.twoLetterCode;
                  }))
          },
          trophies: makeTrophies(res),
          badges: makeBadges(res),
          spBar: StoryverseNavigationQuery$LiteracyplanetClientSxEntry.convertSpBar(Belt_Array.get(res.storyverse_user_points_view, 0)),
          avatar: res.getPlayerAvatar,
          myUser: {
            gems: makeMyGems(res),
            thumbsUp: defaultSocial(res.thumbsUp),
            highFives: defaultSocial(res.highFives)
          }
        };
}

var Q = QueryHook2$LiteracyplanetClientFlags.Make({
      Raw: Raw,
      use: use,
      useFetch: useFetch
    });

function use$1() {
  var fetchProfile = Q.useAsync();
  var user = UserContext$LiteracyplanetClientFlags.use();
  var myUserId = user.userId;
  return async function (userId) {
    return Belt_Option.map(await fetchProfile({
                    nextUuid: userId,
                    userId: userId,
                    userUuid: userId,
                    myUserId: myUserId,
                    myUserIdUuid: HasuraTypes$LiteracyplanetClientFlags.encode(myUserId)
                  }), handleResponse);
  };
}

var PlayerEquippedFragment;

var StoryverseUserPointsFragment;

export {
  PlayerEquippedFragment ,
  StoryverseUserPointsFragment ,
  GetProfile ,
  makeBadges ,
  makeTrophies ,
  makeMyGems ,
  defaultSocial ,
  handleResponse ,
  Q ,
  use$1 as use,
}
/* query Not a pure module */
